import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/Blog.css";
import Footer from "../components/Footer";

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Get translated list of posts
  const blogs = t("blog.posts", { returnObjects: true }) || [];

  // Find post that matches this ID
  const blog = blogs.find((b) => String(b.id) === String(id));

  // -------- Not found (keeps footer at bottom too) --------
  if (!blog) {
    return (
      <div className="page-wrapper">
        <div className="page-content">
          <div className="blog-post-page">
            <div className="blog-post-container">
              <button className="back-btn" onClick={() => navigate(-1)}>
                ← {t("blog.back")}
              </button>
              <h1 className="post-title">{t("blog.notFound")}</h1>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // -------- Normal render --------
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="blog-post-page">
          <div className="blog-post-container">
            <button className="back-btn" onClick={() => navigate(-1)}>
              ← {t("blog.back")}
            </button>

            <h1 className="post-title">{blog.title}</h1>
            <p className="post-date">{blog.date}</p>

            <img src={blog.image} alt={blog.title} className="post-image" />

            <div className="post-content">
              {String(blog.content)
                .split("\n")
                .map((paragraph, idx) => {
                  const text = paragraph.trim();
                  return text ? <p key={idx}>{text}</p> : null;
                })}
            </div>
          </div>
        </div>
      </div>

      {/* Footer stays at the bottom, outside scrollable content */}
      <Footer />
    </div>
  );
};

export default BlogPost;